module.exports = __webpack_public_path__ + "static/media/mudwalker.7a7ada73.mp4";